import React, { useEffect, useRef } from 'react';

export const ChatsView: React.FC = () => {
  const hasOpened = useRef(false);

  useEffect(() => {
    if (hasOpened.current) {
      return;
    }
    hasOpened.current = true;

    const token = localStorage.getItem('mzt-token') || '';
    const chatUrl = `${process.env.REACT_APP_CHAT_APP_URL}/monitor?token=${token}`;

    window.open(chatUrl, '_blank');

    // Wróć do poprzedniej strony po otwarciu okna
    window.history.back();
  }, []);

  return null;
};
